import React, { useEffect, useState } from "react";
import "../Components/Modal.css";
import modallogo from "../Assets/Images/Homepage/modal-logo.png";

const Modal = ({ isOpen, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check sessionStorage to see if the modal should be hidden
    const modalDismissed = sessionStorage.getItem("modalDismissed");
    if (!modalDismissed) {
      setIsVisible(isOpen);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem("modalDismissed", "true"); // Set flag in sessionStorage
    onClose(); // Call the parent component's onClose function if necessary
  };

  if (!isVisible) return null; // Don't render the modal if it's not visible

  return (
    <div
      className={`modalBackdrop ${isVisible ? "is-open" : ""}`}
      onClick={handleClose}
    >
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="closeBtn">
          <button onClick={handleClose}>&times;</button>
        </div>
        <div className="modalContainer">
          <h3>Curious about how much your home is worth?</h3>
          <p>
            Get a free valuation and find out how much your property could sell
            or let for.
          </p>
          <div className="modalButtom">
            <button>
              <a href="/book-valuation">Request a Valuation</a>
            </button>
            <img src={modallogo} alt="modal_icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
